import React from "react";
import { useTranslation } from "react-i18next";

export const Customers = () => {
  const [t] = useTranslation("global");

  return (
    <section className="wrapper_customers">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-7 box_customer">
            <div className="drawer__customer">
              <h6 className="mb-5 ttls_small">
                {t("customers.small_customer")}
              </h6>
              <h1 className="mt-5 ttls ttls_sections">
                {" "}
                {t("customers.title_customer_one")}{" "}
                <span className="bg_span blue">
                  {t("customers.title_customer_two")}
                </span>
              </h1>
              <p className="pb-4 mt-4 paragraphs">
                {t("customers.customer_information")}
              </p>
              <hr />
              <div className="text-center row box_logos_custumers align-items-center justify-content-center">
                <div className="col-sm-4">
                  <img
                    className=""
                    src="assets/imgs/customers/RVOL_LOGOTIPO_01.webp"
                    alt="Somos Red Companies, marketing, diseño y desarrollo web, tecnología, Red Voucher, Red Voucher online, Red Access, Red Bear, Red Pay"
                  />
                </div>
                <div className="col-sm-4">
                  <img
                    className=""
                    src="assets/imgs/customers/RVOL_LOGOTIPO_02.webp"
                    alt="Somos Red Companies, marketing, diseño y desarrollo web, tecnología, Red Voucher, Red Voucher online, Red Access, Red Bear, Red Pay"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="bg_customer"></div>
        </div>
      </div>
    </section>
  );
};
